import { cn } from '@core/utils';

export const DesktopTitle = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <h1
      className={cn(
        'font-700 text-Gray-900 typo-h5',
        'mobile-tablet:sr-only',
        className,
      )}
    >
      {children}
    </h1>
  );
};
